import React from "react"
import { Card, Table, Divider, Row, Col, Typography, TableColumnsType } from "antd"
import { textNumberFormater } from "../../utils"

const { Text } = Typography

export interface MovementDetailItemsCardProps {
  title: string
  columnsItems: TableColumnsType
  itemListData: any[]
  beforeTaxes: number
  discounts: number
  sumTaxes: number
  total: number
}

const MovementDetailItemsCard: React.FC<MovementDetailItemsCardProps> = ({
  title,
  columnsItems,
  itemListData,
  beforeTaxes,
  discounts,
  sumTaxes,
  total,
}) => {
  return (
    <Card title={`Ítems ${title}`} className="card-shadow">
      <Table 
        columns={columnsItems} 
        dataSource={itemListData} 
        pagination={false} 
        size="small"
        rowKey="id"
        scroll={{ x: 600 }}
      />
      <Divider />
      <Row justify="end">
        <Col xs={24} sm={12} md={10}>
          <div style={{ textAlign: 'right' }}>
            <p><Text strong>Subtotal:</Text> {textNumberFormater(beforeTaxes)}</p>
            <p><Text strong>Descuentos:</Text> {textNumberFormater(discounts)}</p>
            <p><Text strong>Impuestos:</Text> {textNumberFormater(sumTaxes)}</p>
            <p>
              <Text strong style={{ fontSize: 18 }}>TOTAL:</Text>{" "}
              <Text strong style={{ fontSize: 18, color: '#1890ff' }}>
                {textNumberFormater(total)}
              </Text>
            </p>
          </div>
        </Col>
      </Row>
    </Card>
  )
}

export default MovementDetailItemsCard
